var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconPopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 43,
    viewBox: "0 0 38 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.759 3.00207L27.6257 7.06732H33.6476C35.499 7.06732 37 8.5658 37 10.4143V12.8929C37 14.1567 35.9738 15.1812 34.708 15.1812H3.29214C2.02622 15.1812 1 14.1567 1 12.8929V10.4143C1 8.5658 2.50096 7.06732 4.35251 7.06732H10.3744L12.2411 3.00207C12.8013 1.78212 14.0223 1 15.3665 1H22.6336C23.9778 1 25.1987 1.78212 25.759 3.00207Z",
    stroke: "#E65A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4891 15.3516V35.1352C33.4891 38.9267 30.4485 42.0002 26.6979 42.0002H11.305C7.55439 42.0002 4.51392 38.9267 4.51392 35.1352V15.3516",
    stroke: "#E65A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1458 23.3589V33.6278M22.8582 23.3589V33.6278",
    stroke: "#E65A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconPopup);
export default __webpack_public_path__ + "static/media/deleteIconPopup.c279271454aa0e36ca797cdb070e3a7b.svg";
export { ForwardRef as ReactComponent };